<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="5" md="5">
                                        <h5 class="mt-2">Agenda del Día</h5>
                                    </v-col>
                                    <v-col cols="7" md="7" class="text-end">
                                        <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">                                        
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip class="ml-2 text-button" @click="menu1 = true" v-bind="attrs" v-on="on" color="info">
                                                    <v-icon class="ml-2" small>events</v-icon>
                                                    {{date1}}
                                                </v-chip>                                        
                                            </template>
                                        <v-date-picker v-model="date1" @input="menu1 = false; change_date()" no-title scrollable></v-date-picker>
                                        </v-menu>
                                        <!-- <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date1" label="Fecha" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date1" @input="menu1 = false; change_date()"></v-date-picker>
                                        </v-menu> -->
                                    </v-col>
                                    <v-col cols="4" md="4" class="mt-0">
                                        <h5 class="mt-2">Hora del Día</h5>
                                    </v-col>
                                    <v-col cols="8" md="8" class="mt-0 text-center d-flex">
                                        <v-select class='text-button' v-model="hora" :items="horas" dense outlined rounded></v-select>
                                        <h1 class="ml-1 mr-1 mt-n1">:</h1>
                                        <v-select class='text-button' v-model="minuto" :items="minutos" dense outlined rounded></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <h5 class="mt-1">Tipo Servicio</h5>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <!-- <v-select placeholder="Selecciona" style="background-color: beige; height: 30px;" @change="change_detail(servicio)" class='text-body-2 black--text' v-model="servicio" :items="myServicio" item-text="descripcion" item-value="id" dense rounded></v-select> -->
                                        <v-select placeholder="Selecciona" style="background-color: beige; height: 30px;" @change="change_detail(10)" class='text-body-2 black--text' v-model="maquina" :items="myMaquinas" dense rounded></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n2">
                                    <v-col cols="12" md="4">
                                        <h5 class="mt-1">Detalle</h5>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-select placeholder="Selecciona" style="background-color: beige; height: 30px;" class='text-body-2 black--text' v-model="detalle" :items="myDetalle" item-text="descripcion" item-value="descripcion" dense rounded></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n2">
                                    <v-col cols="12" md="4">
                                        <!-- <h5 class="mt-1">Profesional</h5> -->
                                         <h5 class="mt-1">Sesiones</h5>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                            <v-text-field maxlength="5" placeholder="Sesiones" style="background-color: beige; height: 30px;" class='text-body-2 black--text' v-model="sesiones" dense rounded></v-text-field>
                                    <!--    <v-select placeholder="Selecciona" style="background-color: beige; height: 30px;" class='text-body-2 black--text' v-model="profesional" :items="myProfesional" dense rounded></v-select> -->
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="8" class="d-flex">
                                        <h5 class="mt-1">Selecciona Cliente</h5>
                                        <v-btn @click="d_cliente=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="12" md="4" class="text-end">
                                        <h5>{{ rut }}</h5>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-9">
                                    <v-col cols="12" md="12" class="mt-n10">
                                        <v-text-field v-if="this.rut!=''" label="Nombre" class='text-body-2' v-model="cliente" dense outlined rounded></v-text-field>
                                        <v-text-field v-else label="Nombre" class='text-body-2' v-model="cliente" dense outlined rounded disabled></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n7">
                                    <v-col cols="12" md="6" class="text-start">
                                        <v-btn v-if="this.rut!='' && this.rut!='1-9'" @click="search_ficha()" x-small color="indigo" text outlined rounded>Ficha Cliente</v-btn>
                                        <v-btn v-else x-small color="grey" text outlined rounded>Ficha Cliente</v-btn>
                                    </v-col>
                                    <v-col cols="12" md="6" class="text-end">
                                        <v-btn @click="agendar_hora()" color="teal" small rounded block dark>Agendar Hora</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6" class="text-center">
                        <h5>SOLARIUM  N°1</h5>
                        <v-row class="mt-1">
                            <v-col v-for="item in myAgenda_SOL01" :key="item.id" cols="12" md="6" class="text-start">
                                <v-card v-if="item.Maquina=='SOLARIUM 1'"  rounded="xl" style="background-color: beige;">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="8" md="8" class="d-flex">
                                                <v-chip color="#c1680e" small dark><h4 class="ml-n1">{{ item.Hora }}</h4></v-chip>
                                                <h6 class="ml-2 mt-1 grey--text">{{ item.Profesional }}</h6>
                                            </v-col>
                                            <v-col cols="4" md="4" class="text-end">
                                                <v-icon @click="delete_agenda(item.ID)" class="ml-2" color="red" small>delete</v-icon>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n5">
                                            <v-col cols="12" md="12">
                                                <h5>{{ item.Cliente }} {{ item.Sesiones }}</h5>
                                                <h6 class="grey--text">{{ item.Servicio }} - {{ item.Detalle }}</h6>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="12" md="6" class="text-center">
                        <h5>SOLARIUM  N°2</h5>
                        <v-row class="mt-1">
                            <v-col v-for="item in myAgenda_SOL02" :key="item.id" cols="12" md="6" class="text-start">
                                <v-card v-if="item.Maquina=='SOLARIUM 2'"  rounded="xl" style="background-color: beige;">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="8" md="8" class="d-flex">
                                                <v-chip color="#c1680e" small dark><h4 class="ml-n1">{{ item.Hora }}</h4></v-chip>
                                                <h6 class="ml-2 mt-1 grey--text">{{ item.Profesional }}</h6>
                                            </v-col>
                                            <v-col cols="4" md="4" class="text-end">
                                                <v-icon @click="delete_agenda(item.ID)" class="ml-2" color="red" small>delete</v-icon>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n5">
                                            <v-col cols="12" md="12">
                                                <h5>{{ item.Cliente }} {{ item.Sesiones }}</h5>
                                                <h6 class="grey--text">{{ item.Servicio }} - {{ item.Detalle }}</h6>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <!-- <v-row>
                    <v-col v-for="item in myAgenda" :key="item.id" cols="12" md="3">
                        <v-card rounded="xl" style="background-color: beige;">
                            <v-container>
                                <v-row>
                                    <v-col cols="8" md="8" class="d-flex">
                                        <v-chip color="#c1680e" small dark><h4 class="ml-n1">{{ item.Hora }}</h4></v-chip>
                                        <h6 class="ml-2 mt-1 grey--text">{{ item.Profesional }}</h6>
                                    </v-col>
                                    <v-col cols="4" md="4" class="text-end">
                                        <v-icon @click="delete_agenda(item.ID)" class="ml-2" color="red" small>delete</v-icon>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n5">
                                    <v-col cols="12" md="12">
                                        <h5>{{ item.Cliente }} {{ item.Sesiones }}</h5>
                                        <h6 class="grey--text">{{ item.Servicio }} - {{ item.Detalle }}</h6>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row> -->
            </v-container>
        </div>
            <div style="height: 50px;"></div>
            <v-footer height="50" color="#c1680e" fixed></v-footer>

        <v-dialog v-model="d_cliente" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Clientes
                    <v-spacer></v-spacer>
                    <v-icon @click="d_cliente=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <div class="hidden-sm-and-down"> <!-- Full Screen -->
                        <v-text-field v-model="search" label="Buscar" style="width: 250px;"></v-text-field>
                        <v-data-table height="300px" fixed-header @click:row="handClients" dense 
                            :search="search" :headers="titulo" :items="myClientes" 
                            :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" 
                            hide-default-footer class="elevation-1 text-size">
                        </v-data-table>
                    </div>
                    <div class="hidden-sm-and-up"> <!-- Mobile Screen -->
                        <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Rut</th>
                                    <th style="background-color: lightgrey;">Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handClients(item)" v-for="item in myClientes" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Rut }}</span></td>
                                    <td><span class="text-body-2">{{ item.Cliente }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="d_ficha" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Ficha Cliente
                    <v-spacer></v-spacer>
                    <v-icon @click="d_ficha=false">close</v-icon>
                </v-card-title>
                <v-card-subtitle>
                  {{ rut }} {{ cliente }}
                </v-card-subtitle>
                <v-card-text>
                    <h5>Servicios</h5>
                    <v-simple-table fixed-header dense class="text-size">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">Fecha</th>
                                <th style="background-color: lightgrey;">Servicio</th>
                                <th style="background-color: lightgrey;">Detalle</th>
                                <th style="background-color: lightgrey;">Sesiones</th>
                                <th style="background-color: lightgrey;">Agenda</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in myFicha.atencion" :key="item.ID">
                                <td><span class="text-caption">{{ item.Fecha }}</span></td>
                                <td><span class="text-caption">{{ item.Servicio }}</span></td>
                                <td><span class="text-caption">{{ item.Detalle }}</span></td>
                                <td class="text-center"><span class="text-caption">{{ item.Sesion }}</span></td>
                                <td class="text-center"><span class="text-caption">{{ item.Agenda }}</span></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <!-- <h5>Agenda</h5>
                    <v-simple-table fixed-header dense class="text-size">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">Fecha</th>
                                <th style="background-color: lightgrey;">Hora</th>
                                <th style="background-color: lightgrey;">Servicio</th>
                                <th style="background-color: lightgrey;">Detalle</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in myFicha.agenda" :key="item.ID">
                                <td><span class="text-caption">{{ item.Fecha }}</span></td>
                                <td><span class="text-caption">{{ item.Hora }}</span></td>
                                <td><span class="text-caption">{{ item.Servicio }}</span></td>
                                <td><span class="text-caption">{{ item.Detalle }}</span></td>
                            </tr>
                        </tbody>
                    </v-simple-table> -->
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 11pt !important;
    height: 30px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import axios from "axios";
export default {
    name: 'Agenda',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        menu1:false,
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

        horas:['08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
        minutos:['00','05','10','15','20','25','30','35','40','45','50','55'],
        hora:'',
        minuto:'',
        myAgenda:[],
        myAgenda_SOL01:[],
        myAgenda_SOL02:[],

        detalle:'',
        detalle_servicio:[],
        myDetalle:[],
        servicio:0,
        txt_servicio:'',
        myServicio:[],
        profesional:'',
        myProfesional:[],
        rut:'',
        cliente:'',
        myClientes:[],
        d_cliente:false,
        d_ficha:false,
        myFicha:[],
        allUser:[],
        sesiones:'',
        search:'',
        titulo:[
          {text: 'Rut',align: 'start',sortable: true, value: 'Rut', width:'30%', class:['backgroud-color: grey ']},
          {text: 'Cliente',align: 'start',sortable: true, value: 'Cliente', width:'70%', class:['backgroud-color: grey ']},
        ],
        page: 1,
        itemsPerPage: 1000000,
        pageCount: 0,
        maquina:'',
        myMaquinas:['SOLARIUM 1', 'SOLARIUM 2'],

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(4);
            if(parseInt(this.bloqueo)!=0){
                await this.search_users();
                await this.search_clientes();
                await this.search_services();
                await this.search_details();
                await this.search_agenda();
            };
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        change_detail(service){
            console.log(service);
            this.myDetalle=[];
            //buscar el txt del servicio
            const found = this.myServicio.filter(res => parseInt(res.id) == parseInt(service));
            if(found.length!=0){ this.txt_servicio = found[0].descripcion };
            //filtrar el detalle del servicio por id
            const filter = this.detalle_servicio.filter(res => res.id_servicio == service);
            if(filter.length!=0){
                this.myDetalle = filter
            }
        },
        handClients(item){
            this.rut=item.Rut;
            this.cliente=item.Cliente;
            this.d_cliente=false
        },
        async change_date(){
            this.loading=true;
            this.clsInput();
            await this.search_agenda();
            this.loading=false;
        },
        async search_agenda(){
            let temp_agenda = [];
            this.myAgenda = [];
            this.myAgenda_SOL01 = [];
            this.myAgenda_SOL02 = [];
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'fecha' :  this.date1,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/get/agenda/',params,{headers});
                const datos = res.data;
                console.log('agenda',datos);
                if(datos[0].existe=='si'){
                    const found = this.allUser.filter(res => (res.usuario).toUpperCase() == (this.user).toUpperCase());
                    if(found.length!=0){
                        const mytipo = found[0].tipo;
                        if(mytipo!='Profesional'){
                            temp_agenda = datos;
                        } else {
                            datos.forEach(element => {
                                if((element.Profesional).toUpperCase() == (this.user).toUpperCase()){
                                    temp_agenda.push(element)
                                }
                            });
                        }
                    }
                }                                
            } catch (error) {
                console.log(error)
            };
            this.myAgenda = temp_agenda;
            //separar por maquina
            if(this.myAgenda.length!=0){
                const Maquina_1 = this.myAgenda.filter(res => res.Maquina=='SOLARIUM 1');
                this.myAgenda_SOL01 = Maquina_1;
                const Maquina_2 = this.myAgenda.filter(res => res.Maquina=='SOLARIUM 2');
                this.myAgenda_SOL02 = Maquina_2;
            }
        },
        async search_clientes(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'clients' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/clients/',params,{headers});
                const datos = res.data;
                console.log('clientes',datos);
                if(datos[0].existe=='si'){
                    this.myClientes = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_services(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : '10' // solo solarium
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/services/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myServicio.push({
                            'id': element.ID,
                            'descripcion': element.Descripcion
                        });
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_users(){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    this.allUser = datos;
                    this.profesional = 'solarium';
                    // datos.forEach(element => {
                    //     if(element.tipo=='Profesional'){
                    //         this.myProfesional.push(element.usuario)
                    //     }
                    // })
                }
            } catch (error) {
                console.log(error);
            }
        },
        async search_details(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/detail/services/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    console.log('Detail', datos);
                    datos.forEach(element => {
                        this.detalle_servicio.push({
                            'id_servicio': element.Id_Servicio,
                            'descripcion': element.Descripcion,
                            'valor': element.Costo
                        });
                    })
                }
            } catch (error) {
                console.log(error)
            };
        },
        async agendar_hora(){
            this.hora = '' + this.hora;
            this.minuto = '' + this.minuto;
            this.detalle = '' + this.detalle;
            this.cliente = '' + this.cliente;
            this.profesional = '' + this.profesional;
            console.log('profesional', this.profesional);
            if(this.hora!=null && this.hora!='' 
                && this.minuto!=null && this.minuto!=''
                    && this.detalle!=null && this.detalle!=''
                        && this.detalle!=null && this.detalle!=''
                            && this.profesional!=null && this.profesional!=''){
                //const valid = await this.valida_hora();
                //console.log('valid',valid)
                const valid = false;
                if(!valid){
                    this.loading=true;
                    try {
                        const headers = {
                            'Content-Type' : 'application/json',
                            'Authorization' : 'Token ' + this.apikey
                        };
                        const hora_agenda = this.hora + ':' + this.minuto;
                        const params = {
                            'contrato' : this.contrato,
                            'user' :  this.user,
                            'fecha' :  this.date1,
                            'hora': hora_agenda,
                            'servicio': this.txt_servicio,
                            'detalle': this.detalle,
                            'maquina': this.maquina,
                            'profesional': this.profesional,
                            'rut': this.rut,
                            'cliente': this.cliente,
                            'sesiones': this.sesiones
                        };
                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/agendar/',params,{headers});
                        const datos = res.data;
                        if(datos[0].existe=='si'){
                            this.clsInput();
                            await this.search_agenda();
                            this.color_snack='success';
                            this.mensaje='Hora agenda ingresada';
                            this.snack=true
                        }                        
                    } catch (error) {
                        console.log(error)
                        this.color_snack='error';
                        this.mensaje='Error, informar a soporte';
                        this.snack=true
                    };
                    this.loading=false
                } else {
                    this.color_snack='error';
                    this.mensaje='La Hora ya tiene agenda';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Datos para agendar invalidos';
                this.snack=true
            }
        },
        // async valida_hora(){
        //     let result = false;
        //     if(this.myAgenda.length!=0){
        //         const hora_agenda = this.hora + ':' + this.minuto + ':00';
        //         const filter = this.myAgenda.filter(res => res.Fecha == this.date1 
        //                                                 && res.Hora == hora_agenda
        //                                                 && res.Servicio == this.txt_servicio
        //                                                 && res.Detalle == this.detalle
        //                                                 && res.Profesional == this.profesional
        //                                             );
        //         if(filter.length!=0){ 
        //             result = true 
        //         }
        //     }
        //     return result
        // },
        clsInput(){
            this.servicio = 0;
            this.txt_servicio = '';
            this.detalle = '';
            this.myDetalle=[];
            //this.profesional = '';
            this.rut = '';
            this.cliente = '';
            //this.date1 = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            this.hora='';
            this.minuto='';
            this.sesiones='';
            this.maquina='';
        },
        async delete_agenda(id){
            this.loading=true;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/agenda/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    await this.search_agenda();
                    this.color_snack='success';
                    this.mensaje='Hora agenda eliminada';
                    this.snack=true
                } else {
                    this.color_snack='error';
                    this.mensaje='Hora agenda no eliminada';
                    this.snack=true
                }
            } catch (error) {
                console.log(error);
                this.color_snack='error';
                this.mensaje='Error, informar a soporte';
                this.snack=true
            };
            this.loading=false;
        },
        async search_ficha(){
            this.loading=true;
            try {
                this.myFicha=[];
                let temp_atencion=[];
                let temp_agenda=[];
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'rut' : this.rut
                };
                const res_atencion = await axios.post(process.env.VUE_APP_URL + '/api/v1/client/atencion/',params,{headers});
                const data_atencion = res_atencion.data;
                console.log('data_atencion', data_atencion)
                if(data_atencion[0].existe=='si'){
                    temp_atencion=data_atencion;
                    const res_agenda = await axios.post(process.env.VUE_APP_URL + '/api/v1/client/agenda/',params,{headers});
                    const data_agenda = res_agenda.data;
                    if(data_agenda[0].existe=='si'){
                        temp_agenda=data_agenda;
                    };
                    //agrupamos la cantidad de servicios agendados
                    let group_services = [];
                    temp_agenda.forEach(element => {
                        if(group_services.length!=0){
                            const found = group_services.filter(res => res.Servicio == element.Servicio && res.Detalle == element.Detalle);
                            if(found.length!=0){
                                const more = parseFloat(found[0].cantidad) + 1;
                                found[0].cantidad = more
                            } else {
                                group_services.push({
                                    Servicio: element.Servicio,
                                    Detalle: element.Detalle,
                                    cantidad: 1
                                })
                            }
                        } else {
                            group_services.push({
                                Servicio: element.Servicio,
                                Detalle: element.Detalle,
                                cantidad: 1
                            })
                        }
                    });
                    //preparamos la atencion
                    temp_atencion.forEach(element => {
                        const found = group_services.filter(res => res.Servicio == element.Servicio && res.Detalle == element.Detalle);
                        if(found.length!=0){
                            const atencion_sesiones = element.Sesion;
                            const agenda_sesiones = found[0].cantidad;
                            if(parseFloat(agenda_sesiones) >= parseFloat(atencion_sesiones)){
                                element.Agenda = atencion_sesiones;
                                found[0].cantidad = parseFloat(agenda_sesiones) - parseFloat(atencion_sesiones)
                            } else{ //si es menor
                                element.Agenda = agenda_sesiones;
                                found[0].cantidad = 0;
                            } 
                        }
                    });
                    //llenamos la ficha
                    this.myFicha={
                        'atencion': temp_atencion,
                        'agenda': temp_agenda
                    };
                    //dejamos solo la ficha por el servicio de Solarium
                    console.log('myFicha', this.myFicha)
                    this.d_ficha=true;
                }
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        }

    }
}
</script>